export type ReportEditDocument = {
  name: string;
  url: string;
  size?: number;
};

export type ReportEditMetric = {
  key?: string;
  plan: number | null;
  fact: number | null;
};

export type ReportEditPayload = {
  id?: number;
  status?: string | null;
  companyName: string;
  reportYear: string;
  comment?: string;
  projectNames?: string;
  projectReadiness?: string;
  rids?: string;
  commercialization?: string;
  stateSupport?: string;
  metrics?: ReportEditMetric[];
  documents?: ReportEditDocument[];
};

export const DEV_REPORT_EDIT_PAYLOAD: ReportEditPayload = {
  id: 1,
  companyName: 'ООО «Компания_название»',
  reportYear: '2026',
  comment:
    'Прототипическая система зрения подразумевает, что действия представителей оппозиции указаны как претенденты на роль ключевых факторов.',
  projectNames:
    'Прототипическая система зрения подразумевает, что действия представителей оппозиции указаны как претенденты на роль ключевых факторов.',
  projectReadiness:
    'Прототипическая система зрения подразумевает, что действия представителей оппозиции указаны как претенденты на роль ключевых факторов. В целом, это убеждённость некоторых оппонентов является качественно новой ступенью инновационных методов управления процессами.',
  rids: 'Прототипическая система зрения подразумевает, что действия представителей.',
  commercialization:
    'Прототипическая система зрения подразумевает, что действия представителей оппозиции указаны как претенденты на роль ключевых факторов.',
  stateSupport:
    'Прототипическая система зрения подразумевает, что действия представителей оппозиции указаны как претенденты на роль ключевых факторов.',
  metrics: [
    { key: 'revenue', plan: 10489904.56, fact: 10489904.56 },
    { key: 'invest_infra', plan: 560904.11, fact: 569904.11 },
    { key: 'invest_rnd', plan: 2489904.21, fact: 2489904.21 },
    { key: 'export_share', plan: 50, fact: 65 },
    { key: 'employees', plan: 64, fact: 64 },
    { key: 'rid', plan: 256, fact: 256 },
  ],
  documents: [
    {
      name: 'Файл. Некоторое название файла PDF',
      url: '/assets/mock-data/Брендбук ИНТЦ.pdf',
      size: 2.4 * 1024 * 1024,
    },
  ],
};

const REPORT_EDIT_DATA_ID = 'residentReportEditData';

export function getReportEditPayloadFromPage(): ReportEditPayload | null {
  const script = document.getElementById(REPORT_EDIT_DATA_ID);
  const rawPayload = script?.textContent?.trim();

  if (rawPayload) {
    try {
      return JSON.parse(rawPayload) as ReportEditPayload;
    } catch (error) {
      console.error('Не удалось разобрать данные отчета для редактирования', error);
      return null;
    }
  }

  if (document.querySelector('.resident-report-detail')) {
    return DEV_REPORT_EDIT_PAYLOAD;
  }

  return null;
}
